import React, { useState, useEffect } from 'react';
import {
  Row, Col, Tab, ButtonGroup, DropdownButton, Dropdown, Button,
} from 'react-bootstrap5';
import axios from 'axios';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import {
  Link,
} from 'react-router-dom';
import Pagination from './Pagination';
import Card from './Card';

export default function PastSessions() {
  const [rawRecords, setRawRecords] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.members.schedule.pastSessions)
      .then((resp) => {
        setRawRecords(resp.data.data);
      });
  }, []);

  if (rawRecords === null) {
    return (
      <LoadingPlaceholder text="Loading..." className="py-5" />
    );
  }

  const recordsOnPage = 10;
  const groupedRecords = Object.groupBy(rawRecords, (_record, index) => parseInt(index / recordsOnPage, 10));
  const eventKey = (page) => `past-sessions-page-${page}`;

  return (
    <>
      {rawRecords.length === 0 ? (
        <p className="py-3 py-sm-5 text-center">
          You have no sessions completed.
        </p>
      ) : (
        <Tab.Container
          id="past-sessions"
          defaultActiveKey={eventKey(0)}
        >
          <Tab.Content className="mt-4">
            {Object.keys(groupedRecords).map((page) => (
              <Tab.Pane key={eventKey(page)} eventKey={eventKey(page)}>
                <Row>
                  {groupedRecords[page].map((record) => (
                    <Col key={record.id} lg={6} className="mb-4">
                      <Card record={record}>
                        <>
                          <ButtonGroup>
                            <DropdownButton
                              as={ButtonGroup}
                              variant="outline-primary"
                              title="More"
                            >
                              {record.attributes.program && (
                                <Dropdown.Item
                                  eventKey={`card-${record.id}-program-page`}
                                  href={routes.members.programs.show(record.attributes.program.id)}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  Program
                                </Dropdown.Item>
                              )}

                              <Dropdown.Item
                                eventKey={`card-${record.id}-chat-page`}
                                href={routes.members.chats.messages(record.attributes.program.chat_id)}
                                target="_blank"
                                rel="noreferrer"
                              >
                                Chat
                              </Dropdown.Item>
                            </DropdownButton>
                          </ButtonGroup>

                          {record.attributes.step ? (
                            <Link
                              to={routes.members.steps.scheduleSummary(record.attributes.step.id)}
                              state={{ step: record, source: 'sessions' }}
                              className={`btn btn-primary ms-3 ${record.attributes.step.skipped ? 'disabled' : ''}`}
                            >
                              View
                            </Link>
                          ) : (
                            <Button className="disabled ms-3">
                              View
                            </Button>
                          )}
                        </>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Tab.Pane>
            ))}
          </Tab.Content>

          <Pagination
            steps={rawRecords}
            pageSize={recordsOnPage}
            eventKey={eventKey}
          />
        </Tab.Container>
      )}
    </>
  );
}
